(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["limetree-quick-shop"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async function(event) {
  var form = event.target;
  if (!form.matches('.lt-quick-shop__form')) return;
  event.preventDefault();
  if (form.dataset.busy === 'true') return;
  var button = form.querySelector('button[type="submit"]');
  var status = form.querySelector('.lt-quick-shop__status');
  var cartLink = form.querySelector('[data-quick-cart]');
  var original = button.textContent;
  var body = new FormData(form);
  form.dataset.busy = 'true';
  button.disabled = true;
  button.textContent = form.dataset.adding;
  status.textContent = '';
  cartLink.hidden = true;
  try {
    var response = await fetch(form.action + '.js', {method: 'POST', body: body, headers: {'Accept': 'application/json'}});
    var result = await response.json();
    if (!response.ok) throw new Error(result.description || form.dataset.error);
    status.textContent = form.dataset.added;
    cartLink.hidden = false;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
  } catch (error) {
    status.textContent = error.message || form.dataset.error;
  } finally {
    form.dataset.busy = 'false';
    button.disabled = false;
    button.textContent = original;
  }
});
  } catch(e) { console.error(e); }
})();

})();
